import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TieredHelpConfig } from '../../models/help-content.model';
import { HelpDetailDialogComponent } from './help-dialog.component';

@Component({
  selector: 'slt-help-tip',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <span
      class="help-tip-wrapper"
      [class.clickable]="hasTier2()"
      [class.inline-mode]="config.displayMode === 'inline'"
      (click)="onClick($event)"
      [matTooltip]="config.tooltip"
      matTooltipPosition="above"
    >
      @if (config.displayMode === 'inline' && config.label) {
        <span class="tip-label">{{ config.label }}</span>
      }
      <mat-icon class="help-icon">help_outline</mat-icon>
    </span>
  `,
  styles: [
    `
      .help-tip-wrapper {
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        color: #757575;
        cursor: help;
        transition: color 0.15s ease-in-out;

        &.clickable {
          cursor: pointer;
          &:hover {
            color: #1976d2;
            .help-icon {
              transform: scale(1.1);
            }
          }
        }

        .help-icon {
          font-size: 16px;
          width: 16px;
          height: 16px;
          transition: transform 0.15s ease-in-out;
        }

        &.inline-mode {
          gap: 0.35rem;
          .tip-label {
            font-size: 0.85rem;
            color: inherit;
          }
        }
      }
    `,
  ],
})
export class HelpTipComponent {
  @Input({ required: true }) config!: TieredHelpConfig;

  private dialog = inject(MatDialog);

  hasTier2(): boolean {
    return !!this.config?.details;
  }

  onClick(event: MouseEvent): void {
    if (!this.hasTier2()) return;

    event.stopPropagation();
    event.preventDefault();

    this.dialog.open(HelpDetailDialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      data: this.config.details,
    });
  }
}
